
    <form [formGroup]="addEditFormTypes" (ngSubmit)="saveOrUpdate()" RestrictFocus>
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row bottom-10-margin">
          <div class="ui-grid-col-4"><label>{{ 'common.certification_name' | translate}}</label></div>
          <div class="ui-grid-col-8"><input formControlName="name" pInputText/></div>
        </div>
      </div>
      <p-footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
                  [disabled]="!addEditFormTypes.valid || !addEditFormTypes.dirty"
                  [label]="'common.add_classification' | translate"></button>
        </div>
      </p-footer>
    </form>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification-types-form.component.ts.ClassificationTypesForm2Component.html